import { FetchReviewedDocumentationCommand } from './FetchReviewedDocumentationCommand'
import { ReviewedDocumentationDTO } from './ReviewedDocumentationDTO'
import { ReviewedDocumentationRepository } from '@/Domain/ReviewedDocumentation/ReviewedDocumentationRepository'
import { AccountId } from '@/Domain/Account'
import { ProcedureId } from '@/Domain/Procedures'

export class FetchReviewedDocumentationCommandHandler {
  private repository: ReviewedDocumentationRepository

  constructor (repository: ReviewedDocumentationRepository) {
    this.repository = repository
  }

  async handle (command: FetchReviewedDocumentationCommand): Promise<ReviewedDocumentationDTO> {
    try {
      const accountId = new AccountId(command.userId())
      const procedureId = new ProcedureId(command.procedureCode())
      const reviewedDocumentation = await this.repository.byProcedureAndAccountId(procedureId, accountId)
      return ReviewedDocumentationDTO.fromReviewedDocumentation(reviewedDocumentation)
    } catch (error) {
      return Promise.reject(error)
    }
  }
}
